/**
 * 公开 API - 活动关联嘉宾
 */

import { httpGet } from '@/services/http';

export interface EventGuest {
  id: number;
  event_id: number;
  guest_id: number;
  role?: string;
  role_en?: string;
  sort_order?: number;
  is_active?: boolean;
  // 关联的嘉宾详细信息
  guest?: {
    id: number;
    name: string;
    name_en?: string;
    title?: string;
    title_en?: string;
    institution?: string;
    institution_en?: string;
    photo?: string;
  };
}

/** GET /api/public/events/:eventId/guests - 获取活动的嘉宾关联列表 */
export async function getPublicEventGuests(eventId: number): Promise<EventGuest[]> {
  try {
    const data = await httpGet<EventGuest[]>(`/public/events/${eventId}/guests`);
    return data || [];
  } catch (error) {
    console.error('获取活动嘉宾失败:', error);
    return [];
  }
}
